// extracted by mini-css-extract-plugin
export default {"tags_title":"AnimalInfoBlock_tags_title__YfWJh","spin":"AnimalInfoBlock_spin__PIm2s"};